import React from "react";
import ReactDOM from "react-dom/client";
import { PrivyProvider } from "@privy-io/react-auth";
import App from "./App";

const PRIVY_APP_ID = "cm7yjajpb00gnuylogmh43amj"; // Replace with your actual Privy App ID

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PrivyProvider appId={PRIVY_APP_ID} scopes={["wallets"]}>
      <App />
    </PrivyProvider>
  </React.StrictMode>
);



